// eslint-disable-next-line import/prefer-default-export
export const CAT_FACT_API = 'https://catfact.ninja';
export const PRIVACY_POLICY_API = 'https://www.emailjs.com/legal/privacy-policy/';
export const EMAIL_JS_API = 'Bcfmdz3E5TNjZHIL1';
export const EMAIL_TEMPLATE = 'template_gmqr0fp';
export const EMAIL_SERVICE = 'service_0016a8a';
